import { render, staticRenderFns } from "./BDTCurrencyFormat.vue?vue&type=template&id=357e69a8&"
import script from "./BDTCurrencyFormat.vue?vue&type=script&lang=js&"
export * from "./BDTCurrencyFormat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports